import auth from './auth'
import settings from './settings'
import users from './users'
import teacher from './teacher'
import admin from './admin'
import payments from './payments'
import lms from './lms'

export default { auth, settings, users, teacher, admin, payments, lms }
